import { render, staticRenderFns } from "./singleSubjectAvg_tea_month_old.vue?vue&type=template&id=6f45d34c&scoped=true&"
import script from "./singleSubjectAvg_tea_month_old.vue?vue&type=script&lang=js&"
export * from "./singleSubjectAvg_tea_month_old.vue?vue&type=script&lang=js&"
import style0 from "./singleSubjectAvg_tea_month_old.vue?vue&type=style&index=0&id=6f45d34c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f45d34c",
  null
  
)

export default component.exports